var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddRefferalIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_497_507",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_497_507)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 33,
    height: 33,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_497_507",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_497_507",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAA7AAAAOwBeShxvQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAANSSURBVFiFtddLbJVVEAfwX1tUfBNfMeCzJqKJb40aQ43BoDsXPoKgEt26bGlcaNCFj4UxMdi4cGGIiVsiJqKiJohPxPqsKCgg4VFjgraGphTRujhz853vu/dyi3xMcvLdmXPOzJw5M3P+l/qpG/fjTezCu5X5FdiMk46Bbb3YhOkYB/FaNn8ePo+5W3FC3cZHQ/nHuAPHZfPLM8caY6Qu4934MpS+HDyciuvi24e38Ufm5JN1ObA4lH6EnpAtwf6Q7w8e1oVsXl3GYU0oXRT82ZhQDvdEyPswWKdx2IsDijtfqPm+p0NeolltFPbiBsyREmsEOw7jwBnS3f4d/FYcqug/hC0Z/yrOqSpaqCiTfPyLD6TwtaJRKQLHZ7KBMDod34Fs7pRwdk9PJnwcq6RaHcHr0t2O4HTciIfC0KfZvpNxD87HcJx+Ca7Gr+HcMGaHnh+kEn0Q6xtKHg1Px3BfixN2Sd1tPNYtw1w8i32KSG3GSq3vvzFW4pv4vZhUDhOYjFMKbwekLtav6Fg3RwQOYCqUTMW6zzoYro4vRMk+E4Kns9Ouqyx+J+TwXMjG43ejnudizwyNj0qJThaOC4O/ts2mq2K+N/ivNdM8fNLB+KbcuDjJvoxf0GbjLdmaP/FXCwdIbfguKYG3Sde1F29Id95d3TCO3zJ+Nn6pGN+q/HL9fhgHjpi+l+o8bwpXYq10p2/himzu3Fj/XV0OPC+dcjkuV37P87ERl+Gx4F9qo68HdysAyXuV+afwk9Q/wKUScBjTHPrq+FnRC6bwIs7MlF+knIRTUnNrUFtA8kQHw9WxNhyelhJyEJdgZ8g24Hblt2CwzYGQMnNohsZfkXrCWbHnYMj/ie+QItNPw/XxXaAZkKxQoUewu43hXXi4ugHzFWHfkBlfqgxIloa8BEi6NNMs3KZ4jsekxPxQetVa0Rqp9hfhfQl47MSJ2ZpJqdnNx014oY2u/0W1A5IjpSog2aIzIFklVUUttFszIOlXBiT92VxLQHI01Cd1y6+kUz6Aa7Bdup5h6Z/QHAng3Blr1tdk373SSX/UuZyH8K0MkNRBXVpjyU6ApOllPBq6QAr3TAHJxXUaz53oFImNx8p4g7qknFgtdc9J6VlfLQHeUtj/A1Rmeu6PcXjmAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddRefferalIcon);
export default __webpack_public_path__ + "static/media/addRefferalIcon.dc5fb124165674f32b187a0815c2c7b8.svg";
export { ForwardRef as ReactComponent };